import { fromJS } from 'immutable'

import { EmulateUser } from './actions';

let defaultState = fromJS({})

export default function userEmulator (state = defaultState, action) {
    state = fromJS(state) // Force immutable in case of rehydration

    switch(action.type) {
        case EmulateUser.event.success:            
            return state
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./client/src/admin/tools/userEmulator/reducer.js